import {api} from '@/http'

// 节假日列表
const getHolidayList = (data, callback, back) => {
  api('/api/Holiday/List', 'post', data, callback, back)
}

// 节假日删除
const delHoliday = (id, callback, back) => {
  api('/api/Holiday/Delete', 'post', {Id: id}, callback, back)
}

// 节假日详情
const detailHoliday = (id, callback, back) => {
  api('/api/Holiday/Detail', 'post', {Id: id}, callback, back)
}

// 节假日添加
const addHoliday = (data, callback, back) => {
  api('/api/Holiday/Insert', 'post', data, callback, back)
}

// 系数列表
const getCoefficientList = (data, callback, back) => {
  api('/api/XiShu/List', 'post', data, callback, back)
}

// 系数删除
const delCoefficient = (id, callback, back) => {
  api('/api/XiShu/Delete', 'post', {Id: id}, callback, back)
}

// 系数详情
const detailCoefficient = (id, callback, back) => {
  api('/api/XiShu/Detail', 'post', {Id: id}, callback, back)
}

// 系数添加
const addCoefficient = (data, callback, back) => {
  api('/api/XiShu/Insert', 'post', data, callback, back)
}

export default {
  getHolidayList,
  delHoliday,
  detailHoliday,
  addHoliday,
  getCoefficientList,
  delCoefficient,
  detailCoefficient,
  addCoefficient
}



// WEBPACK FOOTER //
// ./src/api/performance/index.js